"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.changePassword = void 0;
var api_service_1 = require("../api/api_service");
var changePassword = function (payload) {
    return new Promise(function (resolve, reject) {
        api_service_1.api_service
            .post({
            endPoint: api_service_1.api_service.api_urls.CHANGE_PASSWORD,
            domain: process.env.AUTHENTICATION_SERVER_URL,
            payLoad: payload,
        })
            .then(function (response) {
            console.log('changePassword', response);
            if (response.status === 200) {
                return resolve(response.data);
            }
            throw response.data;
        })
            .catch(function (err) {
            return reject(err);
        });
    });
};
exports.changePassword = changePassword;
